import type { QuerySettings } from '@customTypes/index';
import { useQuery } from '@tanstack/react-query';

import type { ArtistCurrentContractRequest } from './request';
import { artistCurrentContract } from './request';

export const useArtistCurrentContractQuery = (
  params: ArtistCurrentContractRequest,
  settings?: QuerySettings<typeof artistCurrentContract>
) =>
  useQuery({
    queryKey: ['ArtistCurrentContract', params.profileId],
    queryFn: () =>
      artistCurrentContract({
        params,
        config: settings?.config
      }),
    ...settings?.options
  });
